import { type ReactElement, type ReactNode } from "react";

type Props = {
  icon: ReactNode;
  children: ReactNode;
};

export function ConsentReassuranceNote({
  icon,
  children,
}: Props): ReactElement {
  return (
    <aside className="consent-platform-tip">
      <span className="consent-platform-tip-icon" aria-hidden="true">
        {icon}
      </span>
      <p>{children}</p>
    </aside>
  );
}
